import { z } from 'zod'

import { CreditType } from '../constants/booking'
import { dbEntitySchema, listQueryZodFields } from './system'

export const promoExistingSchema = z.object({
  enable: z.boolean().default(false),
  previousMember: z.boolean().default(false),
  message: z.string().nullish(),
  amount: z.number().nullish(),
  points: z.number().default(0),
})

export const promoSchema = dbEntitySchema.extend({
  code: z.string(),
  quantity: z.number().min(-1).default(-1),
  useCount: z.number().min(0).default(0),
  quantityLeft: z.number().optional(),
  notes: z.string().nullish(),
  enable: z.boolean().default(false),
  type: z.nativeEnum(CreditType).nullish(),
  typeId: z.string().nullish(),
  expiration: z.date().nullish(),
  creditExpiration: z.date().nullish(),
  discount: z.string().nullish(),
  campaign: z.string().nullish(),
  message: z.string().nullish(),
  amount: z.number().min(0).default(0),
  points: z.number().min(0).default(0),
  existing: promoExistingSchema.nullish(),
  multiUse: z.boolean().default(false),
  affiliate: z.string().nullish(),
})

export const promoCreateArgsSchema = promoSchema
  .pick({
    code: true,
    quantity: true,
    notes: true,
    enable: true,
    type: true,
    typeId: true,
    expiration: true,
    creditExpiration: true,
    discount: true,
    campaign: true,
    message: true,
    amount: true,
    points: true,
    existing: true,
    multiUse: true,
    affiliate: true,
  })
  .extend({
    useCount: z.number().min(0).optional(),
  })

export const promoUpdateByIdArgsSchema = promoSchema.pick({
  quantity: true,
  amount: true,
  points: true,
  message: true,
  notes: true,
  enable: true,
  expiration: true,
  creditExpiration: true,
  affiliate: true,
  existing: true,
  code: true,
})

export const promoRedemptionResultSchema = z.object({
  amount: z.number().nullish(),
  message: z.string(),
})

export const promosListQuerySchema = z.object({
  ...listQueryZodFields,
  code: z.string().optional().nullable(),
  enable: z.coerce.boolean().optional().nullable(),
})

export const promosListResponseSchema = z.object({
  data: z.array(promoSchema),
})
